import React from 'react'
import ApplicationLogo from '../../components/ApplicationLogo'

export default function Footer() {
    return(
        <footer className="website-main-footer">
            <div className="content-of-website-main-footer content-section-wrapper">

                <div className="logo-of-website-main-footer">
                    <div className="content-of-logo-of-website-main-footer">
                        <ApplicationLogo />
                    </div>
                </div>

                <div className="copyright-of-website-main-footer">
                    <div className="content-of-copyright-of-website-main-footer">
                        <p>© All rights reserved.</p>
                    </div>
                </div>  

            </div>
        </footer>
    )
}